export const InvoicePaymentHistoyTypes = {
    1: "Online Payment",
    2: "Twinfield",
    3: "Manual Payment"
}